import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";
import { AttachmentService } from "../../../core/services/attachment.service";
import { GyzmoDatePickerModule } from "../../../gyzmo-commons/components/date-picker/date-picker.module";
import { IriumInputModule } from "../../../gyzmo-commons/components/irium-input/irium-input.module";
import { IriumSelectModule } from "../../../gyzmo-commons/components/irium-select/irium-select.module";
import { GyzmoTimePickerModule } from "../../../gyzmo-commons/components/time-picker/time-picker.module";
import { PipesModule } from "../../../gyzmo-commons/helpers/pipes/pipes.module";
import { FileService } from "../../../gyzmo-commons/services/file.service";
import { MaterialLineDepartureMatqtConsoComponent } from "./material-line-departure-matqt-conso.component";

@NgModule(
    {
        declarations: [
            MaterialLineDepartureMatqtConsoComponent,
        ],
        imports: [
            CommonModule,
            IonicModule,
            HttpClientModule,
            TranslateModule,
            PipesModule,
            FormsModule,
            GyzmoDatePickerModule,
            GyzmoTimePickerModule,
            IriumInputModule,
            IriumSelectModule,
            ReactiveFormsModule,
        ],
        exports: [
            MaterialLineDepartureMatqtConsoComponent,
        ],
        providers: [
            FileService,
            AttachmentService,
        ],
    })

export class MaterialLineDepartureMatqtConsoModule {
}
